import React, {useEffect, useState} from 'react'
import DHDialog from "../../general/DHDialog";
import DHButtonSave from "../../general/DHButtonSave";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHTextField from "../../general/DHTextField";
import DHSwitch from "../../general/DHSwitch";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";
import DHButtonNew from "../../general/DHButtonNew";
import SelectZeitraumComp from "./SelectZeitraumComp";
import SelectRegionComp from "./SelectRegionComp";
import DHSelect from "../../general/DHSelect";
import {LIGAMODUS} from "../../general/ligaModus";
import SelectRahmenspielplanComp from "./SelectRahmenspielplanComp";
import {LigaSpieltagPaarkreuzsystemComponent} from "../../general/LigaSpieltagPaarkreuzsystemComponent";


export default function LigaVerwaltenDialog({eventOperatorId, selectedLiga, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [working, setWorking] = useState(false);

    const [id, setId] = useState(undefined);
    const [status, setStatus] = useState("NEW");
    const [regionId, setRegionId] = useState("");
    const [zeitraumId, setZeitraumId] = useState("");
    const [rahmenspielplanId, setRahmenspielplanId] = useState("");
    const [name, setName] = useState("");
    const [modusId, setModusId] = useState("");
    const [paarkreuzSystemId, setPaarkreuzSystemId] = useState("");
    const [teamGame, setTeamGame] = useState(false);
    const [hinUndRueckspiel, setHinUndRueckspiel] = useState(true);
    const [aktiv, setAktiv] = useState(true);

    useEffect(() => {
        if( selectedLiga ) {
            setId(selectedLiga.id);
            setName(selectedLiga.name);
            setRegionId(selectedLiga.regionId);
            setZeitraumId(selectedLiga.zeitraumId);
            setRahmenspielplanId(selectedLiga.rahmenspielplanId);
            setModusId(selectedLiga.modusId);
            setPaarkreuzSystemId(selectedLiga.paarkreuzsystemId)
            setTeamGame(selectedLiga.teamGameBeiUnentschieden);
            setHinUndRueckspiel(selectedLiga.hinUndRueckspiel);
            setAktiv(selectedLiga.aktiv);
            setStatus(selectedLiga.status);
        }
    }, [selectedLiga]);

    const save = () => {
        setWorking(true);
        setErrorMessage(undefined);
        let data = {id: id, name: name, regionId: regionId, zeitraumId: zeitraumId,
            rahmenspielplanId: rahmenspielplanId,
            paarkreuzsystemId: paarkreuzSystemId,
            modusId: modusId, teamGameBeiUnentschieden: teamGame, hinUndRueckspiel: hinUndRueckspiel, aktiv: aktiv}
        let url = ConfigUtil.getConfig().resourceUrls.league + "/liga/save/" + eventOperatorId;
        FetchUtil.fetchPost(url,
            data,
            json => {
                setId(json.id);
                setInfoMessage("Speichern erfolgreich...");
                onRefresh();
                setWorking(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setWorking(false);
            });
    }

    const initDialog = () => {
        setId(undefined);
        setName("");
        setAktiv(true);
        setStatus("NEW")
    }

    const isDisabled = () => {
        return name === "" || !zeitraumId || !regionId;
    }

    const getModusModel = () => {
        let rows = [];
        for (const tmp of LIGAMODUS) {
            rows.push({id: tmp.code, value: tmp.name});
        }
        return rows;
    }
    const getButtons = () => {
        return [<DHButtonSave onClick={() => save()} working={working} disabled={isDisabled()}/>,
            <DHButtonNew onClick={() => initDialog()}/>];
    }


    const getDataArea = () => {
        return <div style={{padding: 20}}>
            <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <div style={{marginTop: 10}}>
                <DHTextField id="id-name" label="Liganame" width={500} required={true} value={name} onChange={(text) => setName(text)}/>
            </div>
            <div style={{marginTop: 10}}>
                <SelectZeitraumComp eventOperatorId={eventOperatorId}
                                    zeitraumId={zeitraumId} refreshCounter={0}
                                    onChange={(id) => setZeitraumId(id)} onError={(message) => setErrorMessage(message)}/>
            </div>
            <div style={{marginTop: 10}}>
                <SelectRegionComp eventOperatorId={eventOperatorId}
                                  refreshCounter={0} regionId={regionId} onChange={(id) => setRegionId(id)} onError={(message) => setErrorMessage(message)}/>
            </div>
            <div style={{marginTop: 10}}>
                <SelectRahmenspielplanComp eventOperatorId={eventOperatorId} disabled={status !== "NEW"}
                                           refreshCounter={0} rahmenspielplanId={rahmenspielplanId} onChange={(id) => setRahmenspielplanId(id)} onError={(message) => setErrorMessage(message)}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHSelect id="id-liga-modus" label="Modus" disabled={status !== "NEW"} width={300} onChange={(id) => setModusId(id)} value={modusId} model={getModusModel()}/>
            </div>
            <div style={{marginTop: 10}}>
                <LigaSpieltagPaarkreuzsystemComponent showAsSelect={true} onChange={(paarkreuzsystem) => {
                    setPaarkreuzSystemId(paarkreuzsystem ? paarkreuzsystem.id : undefined);
                }}
                                                      eventOperatorId={eventOperatorId} disabled={false} selectedPaarkreuzsystemId={paarkreuzSystemId}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHSwitch id="id-aktiv" label="Team-Game bei unentschieden" disabled={status !== "NEW"} value={teamGame} onChange={(value) => setTeamGame(value)} required={true}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHSwitch id="id-hinundrueckspiel" label="Hin- und Rückspiel" disabled={status !== "NEW"} value={hinUndRueckspiel} onChange={(value) => setHinUndRueckspiel(value)} required={true}/>
            </div>
            <div style={{marginTop: 10}}>
                <DHSwitch id="id-aktiv" label="Aktiv" value={aktiv} onChange={(value) => setAktiv(value)} required={true}/>
            </div>
        </div>
    }

    return <DHDialog onClose={() => onClose()} title="Liga verwalten" show={true} showCloseButton={true}
                     buttons={getButtons()} comp={getDataArea()}/>
}
